module.exports = __webpack_public_path__ + "static/media/integrationPunchOut.b90cfb94.md";